/** Stable per-browser client identifier used to attribute anonymous-then-registered
 * funnel conversions back to the variant the user saw on landing. */
const STORAGE_KEY = "vita_client_id";

function uuid() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return "cid_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function getClientId() {
  try {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = uuid();
      localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch {
    return "cid_anon";
  }
}
